<template>
  <div class="login-bg">
    <div class="login-box">
      <div class="logo">
        <img src="../assets/logoImg.png">
      </div>
      <div class="title">
        悦 享 互 联 CDN 服 务 中 心
      </div>
      <div class="login-form">
        <form>
          <div class="login-div-input">
            <input placeholder="用户名" />
          </div>
          <div class="login-div-input">
            <input placeholder="密码" type="password" />
          </div>
          <div class="login-div-input">
            <button class="login-btn">登录</button>
          </div>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script type="text/javascript">
import Footer from '../components/Footer'
export default {
  components: {
    Footer
  }
}
</script>
<style lang="scss" scoped>
.login-bg {
  display: block;
  width: 100%;
  height: 90%;
  background: url("../assets/login_bg.jpg") no-repeat;
  background-size: cover;
  position: absolute;
}
.login-box {
  width: 100%;
  display: block;
}
.logo img{
  height: 200px;
  width: 195px;
  margin: 40px auto;
  display: block;
}
.title {
  font-size: 150%;
  color: white;
  text-align: center;
}

.login-form {
  height: 80px;
  margin: 40px auto;
  display: block;
}

.login-div-input {
  height: 36px;
  width: 200px;
  margin: 20px auto;
}

.login-div-input input {
  height: 36px;
  width: 200px;
}

.login-btn {
  width: 200px;
  height: 34px;
  border: none;
  margin: 0px auto;
  color: #fff;
  font-size: 18px;
  background-color: #00bbed;
}

.footer {
  position: absolute;
  width: 100%;
  bottom: 0px;
}
</style>
